import { useEffect, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectCountry, selectSizeC, selectPayment, selectDelivery } from '@store/order/selectors';
import { useLazyGetPriceWithCountryQuery } from '@api/baseApi';
import { AnimalTypeEnum } from '@api/types/AnimalTypeEnum';
import Letter from '@pages/order/summary/footer/Letter';
import SaveButton from '@pages/order/summary/footer/SaveButton';
import SaveButtonCat from '@pages/order/summary/footer/SaveButtonCat';
import { getFormattedPrice } from '@translations/functions';



interface FooterProps {
	animalType: AnimalTypeEnum,
}


const Footer = (props: FooterProps) => {
	const { animalType } = props;
	const { t } = useTranslation('forms');
	
	const country = useSelector(selectCountry);
	const sizeC = useSelector(selectSizeC);
	const payment = useSelector(selectPayment);
	const delivery = useSelector(selectDelivery);

	const [ getPrice, { data, isLoading, isFetching, isError, isSuccess } ] = useLazyGetPriceWithCountryQuery();


	useEffect(() => {
		if (sizeC !== null && sizeC > 0) {
			getPrice({
				size: sizeC,
				animalType: animalType,
				paymentType: payment ? payment.id : undefined,
				deliveryType: delivery ? delivery.id : undefined,
				country: country
			});
		}
	}, [ sizeC, payment, delivery, country ]);


	return (
		<>
			<Letter price={data} country={country} />			
			<div className='order-summary-element footer-element'>
				<p className='gdpr-message'>{t('footer.gdprMessage')}</p>

				{!sizeC &&
					<p className='info-message'>{t('footer.infoMessage')}</p>}

				{isError &&
					<p className='error-message'>{t('footer.errorMessage')}</p>}

				{(isLoading || isFetching) &&
					<p className='loading-message'>{t('footer.loadingMessage')}</p>}

				{isSuccess && data !== undefined && data !== null &&
					<p>{`${t('footer.priceLabel')}: ${getFormattedPrice(country, data.priceWithVat)}`}<br/>
					{`(${getFormattedPrice(country, data.priceNoVat)} ${t('footer.withoutVat')})`}
					</p>}

				{animalType === AnimalTypeEnum.dog
				? <SaveButton price={data} country={country} />
				: <SaveButtonCat price={data} country={country} />}
			</div>
		</>
	);
};

export default memo(Footer);